import React from "react"
import * as Constants from "./constants"
import {
  Progress,
  Spinner,
  Container,
  Alert
} from 'design-react-kit';

export function showProgress() {
  return (
    <Progress
      indeterminate
      label="In elaborazione..."
      role="progressbar"
      tag="div"
    />
  )
}

export function showSpinner() {
  return (
    <Spinner
      active
      double
      small={false}
      tag="span"
    />
  )
}

export function showNotFound() {
  return (
    <Container className="px-2 my-2" id="centro" tag="section">
      <Alert color="warning">Contenuto non disponibile</Alert>
    </Container>

  )
}

export function showTodo() {
  return (
    <Container className="px-2 my-2" id="element" tag="section">
      <Alert color="warning">Contenuto non ancora disponibile</Alert>
    </Container>

  )
}

export function showProtectedResources() {
  return (
    <div>
      {/* <a href={Constants.APP_BASE_NAME + Constants.URL_CALCOLAPAGA_PROTECTED}>
        Torna al servizio Calcola e Paga
      </a>
      <br />
      <a href={Constants.APP_BASE_NAME + Constants.URL_CONSULTAZIONE_PROTECTED}>
        Torna al servizio Consultazione
      </a>
      <br />
      <a href={Constants.APP_BASE_NAME + Constants.URL_RIMBORSI_PROTECTED}>
        Torna al servizio Rimborsi
      </a>
      <br /> */}
      <a href={Constants.APP_BASE_NAME + Constants.URL_SERVIZI_ONLINE}>
        Torna alla Home page
      </a>
      <br />
    </div>
  )
}

export function showUnprotectedResources() {
  return (
    <div>
      {/* <a href={Constants.APP_BASE_NAME + Constants.URL_CALCOLAPAGA_PUBLIC}>
        Torna al servizio Calcola e Paga
      </a>
      <br /> */}
      <a href={Constants.APP_BASE_NAME + Constants.URL_SERVIZI_ONLINE}>
        Torna alla Home page
      </a>
      <br />
    </div>
  )
}

export function showAutenticazioneRichiestaWarning() {
  return (
    <Alert color="warning">È richiesta autenticazione forte!</Alert>
  )
}

export function moveFocusTo(elem_id) {
  if (document.getElementById(elem_id) !== null) {
    document.getElementById(elem_id).focus();
  }
}